import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './_index.module.scss';

function Pagination({
  className,
  'data-testid': dataTestId,
  nextLabel,
  onPageChange,
  pageCount,
  pageRangeDisplayed,
  previousLabel,
  show,
  variant,
  ...other
}) {
  if (!show) {
    return null;
  }
  const isDotsVariant = variant === 'dots';

  return (
    <div data-testid={dataTestId}>
      <ReactPaginate
        activeClassName={styles['pagination-active']}
        breakLabel="..."
        className={classNames(styles['pagination'], className, {
          [styles['pagination-dots']]: isDotsVariant,
        })}
        disabledClassName={styles['pagination-disabled']}
        nextLabel={isDotsVariant ? '→' : nextLabel}
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageLinkClassName={isDotsVariant ? styles['page-dot'] : undefined}
        pageRangeDisplayed={pageRangeDisplayed}
        previousLabel={isDotsVariant ? '←' : previousLabel}
        renderOnZeroPageCount={null}
        {...other}
      />
    </div>
  );
}

Pagination.defaultProps = {
  nextLabel: 'Next >',
  pageRangeDisplayed: 5,
  previousLabel: '< Prev',
  variant: 'default',
};

Pagination.propTypes = {
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  nextLabel: PropTypes.string,
  onPageChange: PropTypes.func,
  pageCount: PropTypes.number.isRequired,
  pageRangeDisplayed: PropTypes.number,
  previousLabel: PropTypes.string,
  show: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dots']),
};

export default Pagination;
